import React, { useState, useEffect } from 'react';
import MViewSummaryAnswerFormList from './MViewSummaryAnswerFormList';
import { stringSimilarity } from 'string-similarity-js';
import { sortArrayObject } from '../../../app/common/helpers/objectHelpers';
import ReactTooltip from 'react-tooltip';
import { roundNumber } from '../../../app/common/helpers/othersHelpers';
import DetailTitle from '../../../app/common/layout/DetailTitle';
import Button from '../../../ui/Button';
import { mdiContentSaveMove, mdiFilePdfBox } from '@mdi/js';
import DetailItem from '../../../app/common/layout/DetailItem';
import { formatDistanceStrict, parseISO } from 'date-fns';
import { id as localeId } from 'date-fns/locale';

function MViewSummaryAnswerForm(props) {
  const {
    id,
    auth,
    scope,
    loading,
    history,
    closeModal,
    studentDetail,
    questions,
    keyAnswers,
    answers,
    scores,
    optScore,
    finalScore,
    detailScore,
    submitTesScores,
  } = props;

  const [state, setState] = useState([]);
  const [totalscr, setTotalscr] = useState({ total: 0, sc: 0, dv: 0 });
  const [isEdit, setIsEdit] = useState(false);
  let qDevider = 0;
  for (let i = 0; i < questions.length; i++) {
    let question = questions[i];
    qDevider = qDevider + 1 * optScore[question.questionType];
  }

  let status = studentDetail?.status && JSON.parse(studentDetail?.status);
  let startTime = status?.startTime && parseISO(status?.startTime);
  let endTime = status?.endTime && parseISO(status?.endTime);
  let diffInTime =
    startTime &&
    endTime &&
    formatDistanceStrict(startTime, endTime, {
      includeSeconds: true,
      locale: localeId,
    });

  useEffect(() => {
    const handleEvent = () => {
      window.location.reload();
    };
    const element = window;
    element.addEventListener('afterprint', handleEvent);
    return () => {
      element.removeEventListener('afterprint', handleEvent);
    };
  }, []);

  function initScore() {
    let getAutoScore = [];
    let getScore;
    let getTotalScore;
    let roundScore;
    answers?.[0] &&
      answers.forEach((ans, index) => {
        let kA =
          keyAnswers?.[0] &&
          keyAnswers.find((ka) => ka.key === ans.key)?.answer;
        let keyAns = (kA ? kA + '' : '').trim();
        let sA = ans?.answer;
        let stAns = (sA ? sA + '' : '').trim();
        if (detailScore) {
          getAutoScore = [...detailScore];
        } else {
          let { score, isCorrect } = handleCountScore(keyAns, stAns, index);

          let obj = {
            no: ans.no,
            key: ans.key,
            keyAns: keyAns,
            stAns: stAns,
            score: isNaN(score) || Number.isNaN(score) ? 0 : score,
            finalScore: isNaN(score) || Number.isNaN(score) ? 0 : score,
            isCorrect: isCorrect,
          };
          getAutoScore = [...getAutoScore, obj];
        }
      });
    if (finalScore) {
      getTotalScore = (parseFloat(finalScore) * qDevider) / 100;
      roundScore = finalScore;
    } else {
      getTotalScore = getAutoScore.reduce(
        (n, { finalScore }) => n + finalScore,
        0
      );
      let checkNaN =
        isNaN(getTotalScore) || Number.isNaN(getTotalScore) ? 0 : getTotalScore;

      getTotalScore = checkNaN;
      getScore = (getTotalScore / qDevider) * 100;
      roundScore = roundNumber(getScore);
    }
    setTotalscr({ total: roundScore, sc: getTotalScore, dv: qDevider });
    setState([...getAutoScore]);
  }

  useEffect(() => {
    initScore();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const convertScore = (scoreCount, val) => {
    if (scoreCount === null) {
      return 'calculate';
    } else if (scoreCount === 0) {
      return 0;
    } else if (scoreCount > 0) {
      let rounder = [10, 100, 1000];
      let roundScore =
        Math.round((scoreCount + Number.EPSILON) * rounder[val - 1]) /
        rounder[val - 1];
      return parseFloat(roundScore);
    }
  };

  const handleCountScore = (keyAns, stAns, index) => {
    let score = 0;
    let isCorrect = false;
    let question = questions?.[index];
    let questionType = question?.questionType;
    if (
      questionType === 'optionQuestion' ||
      questionType === 'rightWrongQuestion'
    ) {
      const string_chop = function (str, size) {
        if (str == null) return [];
        str = String(str);
        size = ~~size;
        return size > 0
          ? str.match(new RegExp('.{1,' + size + '}', 'g'))
          : [str];
      };
      let firstArray = stAns;
      if (stAns.length > keyAns.length) {
        firstArray = string_chop(stAns, keyAns.length)[0];
      }
      if (firstArray === keyAns) {
        score = optScore && 1 * optScore[questionType];
        isCorrect = score === optScore[questionType] ? true : false;
      }
    }

    if (questionType === 'longQuestion') {
      let checkKeyAns = keyAns ? keyAns : 'Jawaban di sini...';
      let scr = checkKeyAns && stAns && stringSimilarity(checkKeyAns, stAns);
      score = (optScore && convertScore(scr, 2) * optScore[questionType]) ?? 0;
      isCorrect = score === optScore[questionType] ? true : false;
    }

    if (questionType === 'shortQuestion') {
      let lowerCaseKeyAns =
        keyAns.length > 0 ? (keyAns + '')?.toLowerCase() : '';
      let lowerCaseStAns = stAns.length > 0 ? (stAns + '')?.toLowerCase() : '';

      if (lowerCaseKeyAns === lowerCaseStAns) {
        score = optScore && 1 * optScore[questionType];
        isCorrect = score === optScore[questionType] ? true : false;
      }
    }
    return { isCorrect, score };
  };

  const handleEdit = (e) => {
    e.preventDefault();
    setIsEdit(!isEdit);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let filteredScores = scores.filter(
      (i) => i.studentTesId !== studentDetail.id
    );
    let newStudentScore = {
      tesId: id,
      studentTesId: studentDetail.id,
      nis: studentDetail.nis,
      detailScore: state,
      finalScore: totalscr.total,
    };
    let newScores = sortArrayObject(
      [...filteredScores, newStudentScore],
      'nis',
      'asc'
    );
    submitTesScores(auth, history, id, newScores);
    setIsEdit(!isEdit);
  };

  const handleSubmitClose = (e) => {
    e.preventDefault();
    let filteredScores = scores.filter(
      (i) => i.studentTesId !== studentDetail.id
    );
    let newStudentScore = {
      tesId: id,
      studentTesId: studentDetail.id,
      nis: studentDetail.nis,
      detailScore: state,
      finalScore: totalscr.total,
    };
    let newScores = sortArrayObject(
      [...filteredScores, newStudentScore],
      'nis',
      'asc'
    );
    submitTesScores(auth, history, id, newScores);
    closeModal();
  };

  const handleEnter = (e) => {
    let inputId = e.target.id;
    let no = inputId.split('_')[0];
    let arrowUp = 'ArrowUp';
    let arrowDown = 'ArrowDown';
    let index;
    let el;
    answers?.[0] &&
      answers.find((i, idx) => {
        index = idx;
        return i.no + '' === no + '';
      });
    if (e.key?.toLowerCase() === 'enter' || e.key === arrowDown) {
      let stateLength = answers?.length;
      if (index + 1 > stateLength - 1) {
        return;
      }
      el = document.getElementById(answers[index + 1].no + '_score');
      if (el) {
        el.focus();
        el.select();
      }
    }
    if (e.key === arrowUp) {
      if (index - 1 < 0) {
        return;
      }
      el = document.getElementById(answers[index - 1].no + '_score');
      if (el) {
        el.focus();
        el.select();
      }
    }
  };

  const onChangeInput = (e, values, questionType) => {
    e.preventDefault();
    let val = e.target.value;
    let limitNumber = optScore[questionType];
    if (
      val.length > 1 &&
      val.charAt(0) + '' === '0' &&
      val.charAt(1) + '' !== '.'
    ) {
      val = val.charAt(1);
    }
    if (isNaN(val)) {
      return;
    }
    if (val.length < 1) {
      val = 0;
    }
    if (val > limitNumber) {
      return;
    }
    let filterState =
      state?.[0] && state?.filter((i) => i.key + '' !== values.key + '');
    let prevItem =
      state?.[0] && state?.find((i) => i.key + '' === values.key + '');
    let newItem = { ...prevItem, finalScore: val };
    let newState = [...filterState, newItem];

    let getScore = newState.reduce(
      (n, { finalScore }) => n + parseFloat(finalScore),
      0
    );
    let getRoundScore = Math.round((getScore + Number.EPSILON) * 100) / 100;
    let getTotalScore = (getRoundScore / qDevider) * 100;

    let roundTotalScore =
      Math.round((getTotalScore + Number.EPSILON) * 100) / 100;
    setTotalscr({ total: roundTotalScore, sc: getRoundScore, dv: qDevider });

    setState(sortArrayObject(newState, 'no', 'asc'));
  };
  /* Print PDF */
  const handlePrintPDF = () => {
    let divContent = document.getElementById('print-page');
    let printContents = divContent.innerHTML;
    let originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    document.title = `Jawaban ${studentDetail?.nis} - ${studentDetail?.siswa}`;
    window.print();
    document.body.innerHTML = originalContents;
  };

  return (
    <div id='print-page'>
      <div>
        <div className='sticky py-3' style={{ top: 0 }}>
          <div className='level mx-3'>
            <DetailTitle
              title={
                <>
                  {studentDetail?.no}. {studentDetail?.nis} -
                  <span className='is-capitalized ml-1'>
                    {studentDetail?.siswa?.toLowerCase()}
                  </span>
                </>
              }
            />

            <div className='level-right'>
              <div className='level-item'>
                <div className='buttons'>
                  {!isEdit && (
                    <>
                      <Button
                        variant='info'
                        icon={mdiFilePdfBox}
                        onClick={(e) => handlePrintPDF(e)}
                      />
                      <div data-for='main' data-tip='Simpan & Tutup'>
                        <Button
                          variant='save'
                          icon={mdiContentSaveMove}
                          onClick={(e) => handleSubmitClose(e)}
                        />
                        <ReactTooltip
                          id='main'
                          place='bottom'
                          type='dark'
                          effect='solid'
                          multiline={true}
                        />
                      </div>
                      <Button variant='edit' onClick={(e) => handleEdit(e)} />
                      <Button variant='back' onClick={closeModal} />
                    </>
                  )}
                  {isEdit && scope?.subm?.['tes_score'] && (
                    <>
                      <Button variant='save' onClick={handleSubmit} />
                      <Button variant='back' onClick={handleEdit} />
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='flex flex-column mx-4 mb-4'>
          <div
            className='notification is-info is-light overflow-auto'
            style={{ fontSize: '0.84em' }}
          >
            <DetailItem
              width={230}
              item='Waktu Mengerjakan'
              detail={diffInTime ?? '-'}
            />
            <DetailItem
              width={230}
              item='Tidak Fokus'
              detail={
                status?.unfocus?.[0] ? status?.unfocus.length + ' kali' : '-'
              }
            />
            <DetailItem
              width={230}
              item='Soal Terjawab'
              detail={status?.activity ? status?.activity : '-'}
            />
          </div>
        </div>

        <div className='content mx-3 overflow-auto'>
          <div className='mb-2 is-size-7'>
            <span className='c-tag has-text-white has-background-info is-light'>
              PG/BS: Nilai Maks. 1
            </span>
            <span className='c-tag has-text-white has-background-info is-light'>
              Singkat: Nilai Maks. 2
            </span>
            <span className='c-tag has-text-white has-background-info is-light'>
              Uraian: Nilai Maks. 3
            </span>
          </div>
          <div className='c-table'>
            <table className='table is-fullwidth is-bordered is-hoverable is-narrow'>
              <thead>
                <tr>
                  <th className='has-text-centered' style={{ width: 50 }}>
                    No
                  </th>
                  <th className='has-text-centered'>
                    Pertanyaan
                  </th>
                  <th className='has-text-centered'>
                    Jawaban Siswa
                  </th>
                  <th className='has-text-centered' style={{ width: 100 }}>
                    Nilai
                  </th>
                </tr>
              </thead>
              <tbody>
                <MViewSummaryAnswerFormList
                  auth={auth}
                  scope={scope}
                  loading={loading}
                  state={state}
                  questions={questions}
                  onChangeInput={onChangeInput}
                  handleEnter={handleEnter}
                  isEdit={isEdit}
                  roundNumber={roundNumber}
                />
                <tr>
                  <td
                    className='has-text-centered middle has-text-weight-semibold'
                    colSpan={3}
                  >
                    Jumlah Nilai (
                    {totalscr?.sc ? Math.round(totalscr?.sc * 100) / 100 : 0} /{' '}
                    {totalscr?.dv} x 100)
                  </td>
                  <td colSpan={3} className='middle has-text-right'>
                    {!isEdit && totalscr?.total}
                    {isEdit && (
                      <TextInput
                        readOnly={true}
                        name='totalScore'
                        style={{ textAlign: 'right', width: '90%', height: 30 }}
                        defaultValue={totalscr?.total ?? 0}
                        placeholder='Jumlah Nilai'
                        label='noLabel'
                      />
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MViewSummaryAnswerForm;

const TextInput = ({
  name,
  type,
  onChange,
  onKeyDown,
  disabled,
  readOnly,
  defaultValue,
  placeholder,
  label,
  style,
}) => (
  <div className='field'>
    {label && label !== 'noLabel' && (
      <label className='label' htmlFor={name}>
        {label}
      </label>
    )}
    <div className='control'>
      <input
        className='input is-size-6'
        id={name}
        readOnly={readOnly}
        onChange={onChange}
        onKeyDown={onKeyDown}
        value={defaultValue}
        type={type}
        disabled={disabled}
        placeholder={placeholder}
        style={{ ...style }}
      />
    </div>
  </div>
);
